import {formatAmount, STATUS_STYLE} from './bid-dashboard-mock';

export {formatAmount, STATUS_STYLE};

export const API = {
  overview: '/business/bid/dashboard/overview',
  pipeline: '/business/bid/dashboard/pipeline',
  charts: '/business/bid/dashboard/charts',
  modules: '/business/bid/dashboard/modules',
  projects: '/business/bid/dashboard/projects',
  bonds: '/business/bid/dashboard/unreturned-bonds',
  waiting: '/business/bid/dashboard/waiting-open',
  activities: '/business/bid/dashboard/activities',
  deadlines: '/business/bid/dashboard/deadline-warnings',
};

export function unwrap(res) {
  return (res && res.data && res.data.data != null) ? res.data.data : null;
}

export function emptyOverview() {
  return {
    year: new Date().getFullYear(),
    tracking_count: 0,
    tracking_amount: 0,
    work_amount: 0,
    opened_amount: 0,
    win_amount: 0,
    active_work: 0,
    urgent_work: 0,
    opened_count: 0,
    win_count: 0,
    win_rate: 0,
    bond_pending: 0,
    bond_amount: 0,
    new_this_month: 0,
    yoy_growth: null,
    info_count: 0,
    work_total: 0,
    waiting_open: 0,
    pending_audit: 0,
  };
}

export function emptyModule(key) {
  const meta = {
    info: {route: 'info', title: '投标分析', icon: 'md-analytics'},
    work: {route: 'work', title: '投标工作', icon: 'md-hammer'},
    open: {route: 'open', title: '开标情况', icon: 'md-clipboard'},
  }[key] || {route: key, title: key, icon: 'md-apps'};
  return {
    ...meta,
    summary: {count: 0, amount: 0},
    statuses: [],
    items: [],
  };
}
